import config from "../../app.json";
import axios from "axios";

import "./profile.scss";
import React, { useState, useEffect, useContext } from "react";
import { Button } from "react-bootstrap";
import FieldText from "../Fields/FieldText";
import FieldTextarea from "../Fields/FieldTextarea";
import AlertComponent from "../AlertComponent";
import FieldProfileUpload from "../Fields/FieldProfileUpload";
import { Context } from "../../Reducers/Store";

function Profile(props) {
  const { setCurrentProfile } = props;
  const [state, dispatch] = useContext(Context);

  const [profileId, setProfileId] = useState(null);
  const [name, setName] = useState(null);
  const [email, setEmail] = useState(null);
  const [location, setLocation] = useState(null);
  const [bio, setBio] = useState(null);
  const [avatar, setAvatar] = useState(null);
  const [previewUrl, setImagePreviewUrl] = useState(null);

  const loadProfile = async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    await axios
      .get(config.API_HM + "/profile")
      .then((result) => {
        setName(result.data.name);
        setEmail(result.data.email);
        setLocation(result.data.location);
        setBio(result.data.bio);
        setProfileId(result.data.id);
        setCurrentProfile(result.data);
      })
      .catch((error) => {
        AlertComponent("Error", error.message ?? "Something went wrong. Profile could not be loaded. Code: 8", { icon: `error` });
      })
      .finally(() => {
        dispatch({ type: "SET_LOADING", payload: false });
      });
  };
  useEffect(() => {
    if (state?.isLogged) {
      loadProfile();
    }
  }, [state?.isLogged]);

  useEffect(() => {
    if (state?.profile) {
      loadProfile();
    }
  }, [state?.profile]);

  const handleSubmit = async () => {
    const payload = {};

    if (name) {
      payload.name = name;
    }

    if (email) {
      payload.email = email;
    }

    if (location) {
      payload.location = location;
    }

    if (bio) {
      payload.bio = bio;
    }

    await saveAvatar();

    await axios
      .put(config.API_HM + "/profile", payload)
      .then(() => {
        AlertComponent("Success", "Profile has been updated");
      })
      .catch((error) => {
        AlertComponent("Error", error?.Message ?? "Something went wrong. Try again in a few minutes.", { icon: `error` });
      });
  };

  const saveAvatar = async () => {
    if (avatar != null) {
      const formData = new FormData();
      formData.append("file", avatar);
      const optionsUpload = {
        headers: { "Content-Type": "multipart/form-data" },
      };

      axios.post(config.API_HM + "/profile/image", formData, optionsUpload).catch(function (error) {
        return AlertComponent("Error", error?.Message ?? "Something went wrong when tried to upload the image.", { icon: `error` });
      });
    }
  };

  useEffect(() => {
    const fetchImage = async () => {

      if(profileId)
      try {
        const response = await axios.get(config.API_HM + "/profile/image/" + profileId, {
          responseType: 'blob',
        });

        const imageUrl = URL.createObjectURL(response.data);
        console.log('imageUrl: ', imageUrl);
        setImagePreviewUrl(imageUrl);
      } catch (error) {
        console.error('Failed to load profile image:', error);
      }
    };

    fetchImage();
  }, [profileId]);


  return (
    <div className="edit-profile">
      <h2>Edit Profile</h2>
      <div className="profile-section">
        <h5>Avatar</h5>
        <div className="profile-avatar-container">
          <FieldProfileUpload
            classNames="profile-avatar-column"
            showButtonUpload={true}
            previewUrl={previewUrl}
            onChange={setAvatar}
            className="upload-picture"
          />
        </div>
      </div>
      <div className="user-info">
        <div className="profile-section">
          <FieldText
            type="text"
            onChange={(x) => setName(x.target.value)}
            label="Name"
            placeholder="Name"
            value={name}
            required={true}
            inputClassName={`profile-input-option name-input`}
          />
        </div>
        <div className="profile-section configuration-disabled">
          <FieldText type="text" label="Email" placeholder="Email" value={email} required={false} disabled={true} inputClassName={`profile-input-option email-input`} />
        </div>
      </div>
      <div className="profile-section">
        <FieldText
          type="text"
          onChange={(x) => setLocation(x.target.value)}
          label="Location"
          placeholder="Location"
          value={location}
          required={true}
          inputClassName={`profile-input-option location-input`}
        />
      </div>
      <div className="profile-section">
        <FieldTextarea
          type="text"
          onChange={(x) => setBio(x.target.value)}
          value={bio}
          label="Bio"
          placeholder="Short Bio"
          required={false}
          rows={3}
          maxLength={null}
          inputClassName={`profile-input-option bio-input`}
        />
      </div>

      <div className="profile-section">
        <Button onClick={handleSubmit} className="big-save-button">
          Save Changes
        </Button>
      </div>
    </div>
  );
}

export default Profile;
